$(function() {
  var premierVideo = document.getElementById('premier-video');
  function closeModal(e) {
    if (e) {
      e.preventDefault();
    }
   	$.magnificPopup.close();
  }

  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: true,
    closeBtnInside: false,
    fixedContentPos: true,
    callbacks: {
      open: function() {
		premierVideo.currentTime = 0;
        premierVideo.play();
      },
      close: function () {
        premierVideo.pause();
      }
    }
  });
  
  $('.video-container').on('click', closeModal);
  $('.video-container video').on('click', function (e){
    e.preventDefault();
    e.stopPropagation();
  });
  
  $(document).on('click', '.popup-modal-dismiss', closeModal);
});